import { memo } from 'react';
import { FamilyInfoTemplate } from 'components/templates/FamilyInfoTemplate';

type Props = {};

export const FamilyInfoPage = memo((_props: Props) => {
	return <FamilyInfoTemplate />;
});
